import { Checkbox } from "@/components/basics/Checkbox";

interface CheckboxCellProps {
  checked: boolean;
  onChange: () => void;
  ariaLabel: string;
}

export function CheckboxCell({
  checked,
  onChange,
  ariaLabel,
}: CheckboxCellProps) {
  return (
    <td
      className="px-3 py-4 whitespace-nowrap justify-center content-center w-4"
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >

      <div className="flex justify-center">
        <Checkbox 
          checked={checked}
          onChange={onChange}
          ariaLabel={ariaLabel}
        />
      </div>
    </td>
  );
}
